/**
 * 공개 카탈로그의 정본 도메인 — 브라우저 번들과 빌드 설정(`vite.config.ts`)이 함께 쓴다.
 *
 * `import.meta.env` 를 여기서 읽지 않는 이유는 vite.config 가 Node 에서 먼저 평가되기 때문이다.
 * 값 해석은 양쪽이 각자 하고, **기본값과 정규화 규칙만** 이 파일이 단일 소스로 갖는다 —
 * 두 곳에 따로 적어 두면 canonical(번들)과 og:url(정적 HTML)이 서로 다른 호스트를 가리키게 된다.
 */

/** 미설정 시 기준 도메인. 배포 서버 빌드에서 `VITE_SITE_URL` 이 비어도 운영 값이 나오도록 한 것. */
export const DEFAULT_SITE_URL = 'https://form.nextpangaea.com';

/** 색인을 허용하는 유일한 호스트. 그 외(dev·프리뷰)는 크롤러에서 통째로 뺀다. */
export const PRIMARY_SITE_URL = DEFAULT_SITE_URL;

/** 후행 슬래시 제거 — 절대 URL 조합에서 `//` 가 생기지 않도록 */
export const normalizeSiteUrl = (value: string | undefined): string =>
  (value && value.trim() !== '' ? value.trim() : DEFAULT_SITE_URL).replace(/\/$/, '');
